import React, { useState, useEffect } from 'react';
import { useTranslation } from 'next-i18next';
import {
  FranchiseCommonSections,
  StyledFranchiseTitleWithDesc,
} from 'views/information-module/common/components';
import { Box } from '@mui/material';
import Typography500 from 'views/common/components/UI/Typography500';
import StyledBox from 'views/information-module/franchise/SupportView/SupportView.styles';
import axios, { API } from 'lib/config/axios';
import Head from 'next/head';
import generateMetaData from 'lib/utils/generateMetaData';
import useErrorsHandler from 'views/rebranded-module/common/hooks/useErrorsHandler';

const supportImage = {
  src: '/imgs/franchise/supportFranchise.jpg',
  alt: 'Franchise Support',
};
const inquiryLink = 'https://docs.google.com/forms/d/1AF2DrjrnVam5RqxBqlETEnOt9btUjTY_sMN38LRnVpA/viewform?edit_requested=true';

const SupportView = (props) => {
  const { t } = useTranslation('fe_er_support_page');
  const handleErrorResponse = useErrorsHandler();
  const { serverData } = props;
  const [seoValues, setSeoValues] = useState(serverData);
  const getSeoValuesData = () => {
    axios
      .get(API.seoValues)
      .then((res) => {
        setSeoValues(res.data);
      })
      .catch((error) => {
        handleErrorResponse(error, false);
      });
  };

  const verticaltabs = [
    {
      label: t('fe_er_common_franchise_header:overview'),
      value: 1,
      href: '#JSVOverview',
    },
    {
      label: t('fe_er_support_page:marketing_header'),
      value: 2,
      href: '#JSVMarketing',
    },
    {
      label: t('fe_er_support_page:training_header'),
      value: 3,
      href: '#JSVTraining',
    },
  ];

  const activeTab = 3;
  useEffect(() => {
    if (!serverData) {
      getSeoValuesData();
    }
  }, []);

  return (
    <>
      <Head>{seoValues && generateMetaData(seoValues)}</Head>

      <StyledBox>
        <FranchiseCommonSections
          activeTab={activeTab}
          verticaltabs={verticaltabs}
          titleWithImage={supportImage}
          titleWithImgText={t('fe_er_common_franchise_header:support')}>
          <Box mb={3} className="SVOverview" id="JSVOverview">
            <StyledFranchiseTitleWithDesc
              className="overview"
              titleVariant="h3"
              component="h2"
              title={t('fe_er_common_franchise_header:overview')}
              description={t('fe_er_support_page:support_text')}
            />
          </Box>

          <Box mb={3} className="SVWorkTogether">
            <StyledFranchiseTitleWithDesc
              titleVariant="h4"
              component="h3"
              title={t('fe_er_support_page:work_header')}
              description={t('fe_er_support_page:work_text')}
            />
          </Box>

          <Box mb={{ lg: 11, md: 8, sm: 6 }}>
            <StyledFranchiseTitleWithDesc
              titleVariant="h4"
              component="h3"
              title={t('fe_er_support_page:field_support_header')}
              description={t('fe_er_support_page:field_support_text', {
                inquiry_link: inquiryLink,
              })}
            />
          </Box>

          <Box mb={3} className="SVMarketing" id="JSVMarketing">
            <StyledFranchiseTitleWithDesc
              titleVariant="h3"
              component="h2"
              title={t('fe_er_support_page:marketing_header')}
              description={t('fe_er_support_page:marketing_text')}
            />
          </Box>

          <Box mb={3}>
            <StyledFranchiseTitleWithDesc
              titleVariant="h4"
              component="h3"
              title={t('fe_er_support_page:branding_header')}
              description={t('fe_er_support_page:branding_text')}
            />
          </Box>

          <Box mb={{ lg: 11, md: 8, sm: 6 }}>
            <StyledFranchiseTitleWithDesc
              titleVariant="h4"
              component="h3"
              title={t('fe_er_support_page:hight_focus_header')}
              description={t('fe_er_support_page:hight_focus_text', {
                inquiry_link: inquiryLink,
              })}
            />
          </Box>

          <Typography500
            variant="h3"
            component="h2"
            mb={2}
            className="SVDark"
            id="JSVTraining">
            {t('fe_er_support_page:training_header')}
          </Typography500>

          <Box mb={2}>
            <StyledFranchiseTitleWithDesc
              titleVariant="h4"
              component="h3"
              title={t('fe_er_support_page:maagment_header')}
              description={t('fe_er_support_page:maagment_text')}
            />
          </Box>

          <Box mb={3} className="SVtraining">
            <StyledFranchiseTitleWithDesc
              titleVariant="h4"
              component="h3"
              title={t('fe_er_support_page:training_program_header')}
              description={t('fe_er_support_page:training_program_text', {
                inquiry_link: inquiryLink,
              })}
            />
          </Box>
        </FranchiseCommonSections>
      </StyledBox>
    </>
  );
};
export { SupportView };
